<form [formGroup]="checkListForm" *ngIf=" true && data && data.length">
  <div class="row" formArrayName="items">
    <ng-container *ngFor="let item of checkListForm.get('items')['controls']; let i = index;">
      <ng-container [formGroupName]="i">
        <div [class]="item.value.cssClass || 'col-md-3'" *ngIf="item.value && item.value.refType !=1">
          <!-- 2 Input Fields 3, Address 4 URL -->
          <ng-container *ngIf="item.value && item.value.refType==2;else address">
            <mat-form-field [matTooltip]="item.value.refLabel" floatLabel="always">
              <mat-label> {{item.value.refLabel}} </mat-label>
              <input matInput formControlName="value" [required]="item.value.mandatory?true:false"
                [placeholder]="'EXTINFO.enter_value'|translate">
              <mat-error *ngIf="item.get(['value']).hasError('required')">
                {{'ERROR.field_is_mandatory'|translate}}
              </mat-error>
            </mat-form-field>
          </ng-container>
          <ng-template #address>
            <ng-container *ngIf="item.value && item.value.refType==3;else URL">
              <div class="attachment-container" (click)="openAddress(item)">
                <div class="input-group  hide-dropdown-arrow">
                  <div class="form-control dropdown pointer link">
                    <span [ngClass]="{'req':item.value.mandatory}">{{item.value.refLabel}}</span>
                    :
                    <ng-container *ngIf="item.value && item.value.value">
                      <ng-container *ngIf="item.value && item.value.value.addressLine1">
                        Addess line 1- {{item.value.value.addressLine1}} ,
                      </ng-container>
                      <ng-container *ngIf="item.value && item.value.value.addressLine2">
                        Addess line 2- {{item.value.value.addressLine2}} ,
                      </ng-container>
                      <ng-container *ngIf="item.value && item.value.value.cityName">
                        City- {{item.value.value.cityName}} ,

                      </ng-container>
                      <ng-container *ngIf="item.value && item.value.value.addressLine1">
                        State- {{item.value.value.stateName}} ,

                      </ng-container>
                      <ng-container *ngIf="item.value && item.value.value.addressLine1">
                        Country- {{item.value.value.countryName}}

                      </ng-container>
                      <ng-container *ngIf="item.value && item.value.value.postalCode">
                        ({{item.value.value.postalCode}} )
                      </ng-container>
                    </ng-container>


                  </div>

                  <div class="input-group-append pointer ">
                    <button class="btn btn-sm js-btn-save" style="min-width: 2rem;">
                      <i class="fa fa-map-marker"></i>
                    </button>
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-template>
          <ng-template #URL>
            <ng-container *ngIf="item.value && item.value.refType==4; else singleSelectDropdown">
              <mat-form-field [matTooltip]="item.value.refLabel" floatLabel="always">
                <mat-label> {{item.value.refLabel}} </mat-label>
                <input matInput formControlName="value" [required]="item.value.mandatory?true:false"
                  [placeholder]="'EXTINFO.enter_value'|translate">
                <span class="btn btn-sm js-btn-save" style="margin-top: -5px;" matSuffix (click)="openUrl()">
                  <i class="fa-globe fa"></i>
                </span>
                <mat-error *ngIf="item.get(['value']).hasError('required')">
                  {{'ERROR.field_is_mandatory'|translate}}
                </mat-error>
              </mat-form-field>
            </ng-container>
          </ng-template>

          <ng-template #singleSelectDropdown>
            <ng-container *ngIf="item.value && item.value.refType==5;else multiSelect">
              <tm-select [form_group]="item" [form_control]="'value'" [data]="item.value.value" [label_block]="1"
                [options]="masters && item.value.tableId ? masters[item.value.tableId]:[]" [label]="item.value.refLabel"
                [placeholder]="'<- -Select - ->'|translate">
              </tm-select>
            </ng-container>
          </ng-template>
          <ng-template #multiSelect>
            <ng-container *ngIf="item.value && item.value.refType==6;else checkbox">
              <tm-multi-select [form_group]="item" [form_control]="'value'" [data]="item.value.value"
                [options]="masters && item.value.tableId ? masters[item.value.tableId]:[]" [label]="item.value.refLabel"
                [placeholder]="'<- -Select - ->'|translate">
              </tm-multi-select>
            </ng-container>
          </ng-template>
          <ng-template #checkbox>
            <ng-container *ngIf="item.value && item.value.refType==7;else segment">
              <mat-checkbox formControlName="value" (change)="checkboxEvent($event,item)">
                {{item.value.refLabel}}
              </mat-checkbox>
              <!-- <mat-form-field floatLabel="always"  class="tm-radio-group">
                <mat-label> {{item.value.refLabel}}</mat-label>
                <input matInput class="d-none"  >
                <span class="tm-data">{{item.value.value}} </span>
              </mat-form-field> -->
            </ng-container>

            <!-- <ng-container *ngIf="item.value && item.value.refType==6">
                                <tm-multi-select [form_group]="item" [form_control]="'value'" [data]="item.value.value"
                                    [options]="masters && item.value.tableId ? masters[item.value.tableId]:[]"
                                    [label]="item.value.refLabel" [placeholder]="'<- -Select - ->'|translate">
                                </tm-multi-select>
                            </ng-container> -->
          </ng-template>
          <ng-template #segment>
            <ng-container *ngIf="item.value && item.value.refType==8;else textarea;">
              <mat-button-toggle-group formControlName="value">
                <mat-button-toggle [value]="item.id"
                  *ngFor="let item of masters && item.value.tableId ? masters[item.value.tableId]:[]">
                  {{item.title}}
                </mat-button-toggle>
              </mat-button-toggle-group>


            </ng-container>
          </ng-template>
          <ng-template #textarea>
            <ng-container *ngIf="item.value && item.value.refType==9;else date;">
              <mat-form-field [matTooltip]="item.value.refLabel" floatLabel="always" style="width: 100%;">
                <mat-label> {{item.value.refLabel}} </mat-label>
                <textarea matInput formControlName="value" [required]="item.value.mandatory?true:false"
                  style="height: 60px;" [placeholder]="'EXTINFO.enter_value'|translate"> </textarea>
                <mat-error *ngIf="item.get(['value']).hasError('required')">
                  {{'ERROR.field_is_mandatory'|translate}}
                </mat-error>
              </mat-form-field>
            </ng-container>
          </ng-template>

          <ng-template #date>
            <ng-container *ngIf="item.value && item.value.refType==10;else datetime;">
              <!-- DATE -->
              <tm-date-picker [form]="item" [controlName]="'value'" [label]="item.value.refLabel"
                [value]="item.value.value" [placeholder]="'<- -Select- ->'">
              </tm-date-picker>
            </ng-container>
          </ng-template>
          <ng-template #datetime>
            <ng-container *ngIf="item.value && item.value.refType==11;else singleFile;">
              <!-- DATE & TIME -->
              <tm-date-time-picker-t2 [form]="item" [controlName]="'value'" [label]="item.value.refLabel"
                [value]="item.value.value" [placeholder]="'<- -Select- ->'"></tm-date-time-picker-t2>
            </ng-container>
          </ng-template>

          <!-- FILE SINGLE -->

          <ng-template #singleFile>
            <ng-container *ngIf="item.value && item.value.refType==12;else multipleFile;">
              <tm-files-v2 [form_group]="item" [form_control]="'value'" [label]="item.value.refLabel"
                [result]="item.value.value" (uploadStatus)="validStatus($event)">
              </tm-files-v2>
            </ng-container>

          </ng-template>

          <!-- FILE Multiple -->

          <ng-template #multipleFile>
            <ng-container *ngIf="item.value && item.value.refType==13;else default;">
              <tm-files-v2 [form_group]="item" [form_control]="'value'" [label]="item.value.refLabel" [multiple]="1"
                [result]="item.value.value" (uploadStatus)="validStatus($event)">
              </tm-files-v2>
            </ng-container>

          </ng-template>
          <ng-template #default>
            <mat-form-field [matTooltip]="item.value.refLabel" floatLabel="always">
              <mat-label> {{item.value.refLabel}} </mat-label>
              <input matInput formControlName="value" [required]="item.value.mandatory?true:false"
                [placeholder]="'EXTINFO.enter_value'|translate">
              <mat-error *ngIf="item.get(['value']).hasError('required')">
                {{'ERROR.field_is_mandatory'|translate}}
              </mat-error>
            </mat-form-field>
          </ng-template>



        </div>
        <div [class]=" 'col-md-2'" *ngIf="item.value.date1Visible">
          <tm-date-picker [form]="item" [controlName]="'date1Value'" [label]="item.value.date1Label"
            [value]="item.value.date1Value">
          </tm-date-picker>
        </div>
        <div [class]=" 'col-md-2'" *ngIf="item.value.date2Visible">
          <tm-date-picker [form]="item" [controlName]="'date2Value'" [label]="item.value.date2Label"
            [value]="item.value.date2Value">
          </tm-date-picker>
        </div>
        <div [class]=" 'col-md-3'" *ngIf="item.value.attachVisible">
          <tm-files-v2 [form_group]="item" [form_control]="'attachValue'" [label]="item.value.attachLabel"
            [result]="item.value.attachValue" (uploadStatus)="validStatus($event)">
          </tm-files-v2>
        </div>
      </ng-container>
    </ng-container>
  </div>

</form>
<form [formGroup]="checkListForm" *ngIf=" false && data && data.length">
  <div class="row" formArrayName="items">
    <ng-container *ngFor="let item of checkListForm.get('items')['controls']; let i = index;">
      <ng-container [formGroupName]="i">
        <div [class]="item.value.cssClass || 'col-md-3'" *ngIf="item.value && item.value.refType !=1">
          <!-- 2 Input Fields 3, Address 4 URL -->
          <ng-container *ngIf="item.value && item.value.refType==2;else address">
            <!-- <mat-form-field [matTooltip]="item.value.refLabel" floatLabel="always">
              <mat-label> {{item.value.refLabel}} </mat-label>
              <input matInput formControlName="value" [required]="item.value.mandatory?true:false"
                [placeholder]="'EXTINFO.enter_value'|translate">
              <mat-error *ngIf="item.get(['value']).hasError('required')">
                {{'ERROR.field_is_mandatory'|translate}}
              </mat-error>
            </mat-form-field> -->


            <mat-form-field floatLabel="always" class="tm-radio-group">
              <mat-label> {{item.value.refLabel}}</mat-label>
              <input matInput class="d-none">
              <span class="tm-data">{{i.value}} </span>
            </mat-form-field>
          </ng-container>
          <ng-template #address>
            <ng-container *ngIf="item.value && item.value.refType==3;else URL">
              <div class="attachment-container" (click)="openAddress(item)">
                <div class="input-group  hide-dropdown-arrow">
                  <div class="form-control dropdown pointer link">
                    <span [ngClass]="{'req':item.value.mandatory}">{{item.value.refLabel}}</span>
                    :
                    <ng-container *ngIf="item.value && item.value.value">
                      <ng-container *ngIf="item.value && item.value.value.addressLine1">
                        Addess line 1- {{item.value.value.addressLine1}} ,
                      </ng-container>
                      <ng-container *ngIf="item.value && item.value.value.addressLine2">
                        Addess line 2- {{item.value.value.addressLine2}} ,
                      </ng-container>
                      <ng-container *ngIf="item.value && item.value.value.cityName">
                        City- {{item.value.value.cityName}} ,

                      </ng-container>
                      <ng-container *ngIf="item.value && item.value.value.addressLine1">
                        State- {{item.value.value.stateName}} ,

                      </ng-container>
                      <ng-container *ngIf="item.value && item.value.value.addressLine1">
                        Country- {{item.value.value.countryName}}

                      </ng-container>
                      <ng-container *ngIf="item.value && item.value.value.postalCode">
                        ({{item.value.value.postalCode}} )
                      </ng-container>
                    </ng-container>


                  </div>

                  <div class="input-group-append pointer ">
                    <button class="btn btn-sm js-btn-save" style="min-width: 2rem;">
                      <i class="fa fa-map-marker"></i>
                    </button>
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-template>
          <ng-template #URL>
            <ng-container *ngIf="item.value && item.value.refType==4; else singleSelectDropdown">
              <mat-form-field [matTooltip]="item.value.refLabel" floatLabel="always">
                <mat-label> {{item.value.refLabel}} </mat-label>
                <input matInput formControlName="value" [required]="item.value.mandatory?true:false"
                  [placeholder]="'EXTINFO.enter_value'|translate">
                <span class="btn btn-sm js-btn-save" style="margin-top: -5px;" matSuffix (click)="openUrl()">
                  <i class="fa-globe fa"></i>
                </span>
                <mat-error *ngIf="item.get(['value']).hasError('required')">
                  {{'ERROR.field_is_mandatory'|translate}}
                </mat-error>
              </mat-form-field>
            </ng-container>
          </ng-template>

          <ng-template #singleSelectDropdown>
            <ng-container *ngIf="item.value && item.value.refType==5;else multiSelect">
              <!-- <tm-select [form_group]="item" [form_control]="'value'" [data]="item.value.value"
                [options]="masters && item.value.tableId ? masters[item.value.tableId]:[]" [label]="item.value.refLabel"
                [placeholder]="'<- -Select - ->'|translate"></tm-select> -->
              <mat-form-field floatLabel="always" class="tm-radio-group">
                <mat-label> {{item.value.refLabel}}</mat-label>
                <input matInput class="d-none">
                <span class="tm-data">{{item.value.value |DynamicPipe :masters && item.value.tableId ?
                  masters[item.value.tableId]: 'tableId' :
                  'title'}} </span>
              </mat-form-field>
            </ng-container>
          </ng-template>
          <ng-template #multiSelect>
            <ng-container *ngIf="item.value && item.value.refType==6;else checkbox">
              <tm-multi-select [form_group]="item" [form_control]="'value'" [data]="item.value.value"
                [options]="masters && item.value.tableId ? masters[item.value.tableId]:[]" [label]="item.value.refLabel"
                [placeholder]="'<- -Select - ->'|translate">
              </tm-multi-select>
            </ng-container>
          </ng-template>
          <ng-template #checkbox>
            <ng-container *ngIf="item.value && item.value.refType==7;else segment">
              <!-- <mat-checkbox formControlName="value" (change)="checkboxEvent($event,item)">
                {{item.value.refLabel}}
              </mat-checkbox> -->
              <mat-form-field floatLabel="always" class="tm-radio-group">
                <mat-label> {{item.value.refLabel}}</mat-label>
                <input matInput class="d-none">
                <span class="tm-data">{{item.value.value==1 ? 'yes' : 'no'}} </span>
              </mat-form-field>
            </ng-container>

            <!-- <ng-container *ngIf="item.value && item.value.refType==6">
                                <tm-multi-select [form_group]="item" [form_control]="'value'" [data]="item.value.value"
                                    [options]="masters && item.value.tableId ? masters[item.value.tableId]:[]"
                                    [label]="item.value.refLabel" [placeholder]="'<- -Select - ->'|translate">
                                </tm-multi-select>
                            </ng-container> -->
          </ng-template>
          <ng-template #segment>
            <ng-container *ngIf="item.value && item.value.refType==8;else textarea;">
              <mat-button-toggle-group formControlName="value">
                <mat-button-toggle [value]="item.id"
                  *ngFor="let item of masters && item.value.tableId ? masters[item.value.tableId]:[]">
                  {{item.title}}
                </mat-button-toggle>
              </mat-button-toggle-group>




            </ng-container>
          </ng-template>
          <ng-template #textarea>
            <ng-container *ngIf="item.value && item.value.refType==9;else date;">
              <!-- <mat-form-field [matTooltip]="item.value.refLabel" floatLabel="always" style="width: 100%;">
                <mat-label> {{item.value.refLabel}} </mat-label>
                <textarea matInput formControlName="value" [required]="item.value.mandatory?true:false"
                  style="height: 60px;" [placeholder]="'EXTINFO.enter_value'|translate"> </textarea>
                <mat-error *ngIf="item.get(['value']).hasError('required')">
                  {{'ERROR.field_is_mandatory'|translate}}
                </mat-error>
              </mat-form-field> -->
              <mat-form-field floatLabel="always" class="tm-radio-group">
                <mat-label> {{item.value.refLabel}}</mat-label>
                <input matInput class="d-none">
                <span class="tm-data">{{i.value}} </span>
              </mat-form-field>
            </ng-container>
          </ng-template>

          <ng-template #date>
            <ng-container *ngIf="item.value && item.value.refType==10;else datetime;">
              <!-- DATE -->
              <!-- <tm-date-picker [form]="item" [controlName]="'value'" [label]="item.value.refLabel"
                [value]="item.value.value" [placeholder]="'<- -Select- ->'">
              </tm-date-picker> -->
              <mat-form-field floatLabel="always" class="tm-radio-group">
                <mat-label> {{item.value.refLabel}}</mat-label>
                <input matInput class="d-none">
                <span class="tm-data">{{item.value.value |date:'medium'}} </span>
              </mat-form-field>
            </ng-container>
          </ng-template>
          <ng-template #datetime>
            <ng-container *ngIf="item.value && item.value.refType==11;else singleFile;">
              <!-- DATE & TIME -->
              <!-- <tm-date-time-picker-t2 [form]="item" [controlName]="'value'" [label]="item.value.refLabel"
                [value]="item.value.value" [placeholder]="'<- -Select- ->'"></tm-date-time-picker-t2> -->
              <mat-form-field floatLabel="always" class="tm-radio-group">
                <mat-label> {{item.value.refLabel}}</mat-label>
                <input matInput class="d-none">
                <span class="tm-data">{{item.value.value |date:'medium'}} </span>
              </mat-form-field>

            </ng-container>
          </ng-template>

          <!-- FILE SINGLE -->

          <ng-template #singleFile>
            <ng-container *ngIf="item.value && item.value.refType==12;else multipleFile;">
              <tm-files-v2 [form_group]="item" [form_control]="'value'" [label]="item.value.refLabel"
                [result]="item.value.value" (uploadStatus)="validStatus($event)">
              </tm-files-v2>
            </ng-container>

          </ng-template>

          <!-- FILE Multiple -->

          <ng-template #multipleFile>
            <ng-container *ngIf="item.value && item.value.refType==13;else default;">
              <tm-files-v2 [form_group]="item" [form_control]="'value'" [label]="item.value.refLabel" [multiple]="1"
                [result]="item.value.value" (uploadStatus)="validStatus($event)">
              </tm-files-v2>
            </ng-container>

          </ng-template>
          <ng-template #default>
            <mat-form-field [matTooltip]="item.value.refLabel" floatLabel="always">
              <mat-label> {{item.value.refLabel}} </mat-label>
              <input matInput formControlName="value" [required]="item.value.mandatory?true:false"
                [placeholder]="'EXTINFO.enter_value'|translate">
              <mat-error *ngIf="item.get(['value']).hasError('required')">
                {{'ERROR.field_is_mandatory'|translate}}
              </mat-error>
            </mat-form-field>
          </ng-template>



        </div>
        <div [class]=" 'col-md-2'" *ngIf="item.value.date1Visible">
          <mat-form-field floatLabel="always" class="tm-radio-group">
            <mat-label> {{item.value.date1Label}}</mat-label>
            <input matInput class="d-none">
            <span class="tm-data">{{item.value.date1Value |date:'medium'}} </span>
          </mat-form-field>

          <!-- <tm-date-picker [form]="item" [controlName]="'date1Value'" [label]="item.value.date1Label"
            [value]="item.value.date1Value">
          </tm-date-picker> -->
        </div>
        <div [class]=" 'col-md-2'" *ngIf="item.value.date2Visible">

          <mat-form-field floatLabel="always" class="tm-radio-group">
            <mat-label> {{item.value.date2Label}}</mat-label>
            <input matInput class="d-none">
            <span class="tm-data">{{item.value.date2Value |date:'medium'}} </span>
          </mat-form-field>
          <!-- <tm-date-picker [form]="item" [controlName]="'date2Value'" [label]="item.value.date2Label"
            [value]="item.value.date2Value">
          </tm-date-picker> -->
        </div>
        <div [class]=" 'col-md-3'" *ngIf="item.value.attachVisible">
          <!-- <mat-form-field floatLabel="always"  class="tm-radio-group">
            <mat-label> {{item.value.date2Label}}</mat-label>
            <input matInput class="d-none"  >
            <span class="tm-data">{{item.value.attachValue}} </span>
          </mat-form-field> -->
          <tm-files-v2 [form_group]="item" [form_control]="'attachValue'" [label]="item.value.attachLabel"
            [result]="item.value.attachValue" (uploadStatus)="validStatus($event)">
          </tm-files-v2>
        </div>
      </ng-container>
    </ng-container>
  </div>

</form>
<!-- 0: {id: 1, title: "None", showMaster: 0}
1: {id: 2, title: "Input Field", showMaster: 0}
2: {id: 3, title: "Address", showMaster: 0}
3: {id: 4, title: "URL", showMaster: 0}
4: {id: 5, title: "Single select dropdown", showMaster: 1}
5: {id: 6, title: "Multi-select dropdown", showMaster: 1}
6: {id: 7, title: "Checkbox", showMaster: 1}
7: {id: 8, title: "Segments", showMaster: 1} -->